import { action, observable } from 'mobx';
import { IAIDashboardList } from '../api/analysis';

class AIDashboardStore {
  // AI看板列表
  @observable aiDashboardList: IAIDashboardList = [];

  @action
  setAIDashboardList(aiDashboardList: IAIDashboardList) {
    this.aiDashboardList = aiDashboardList;
  }
}

export default new AIDashboardStore();
